import { GET_ADMINISTRATORS, GET_DISTRIBUTORS, GET_DISTRIBUTORS_FOR_USER, UPDATE_ADMINISTRATORS, UPDATE_USER_DISTRIBUTORS } from '../constants/action-types';

// INITIALIZE STATE
const initialState = {
    distributors: {},
    currentUserDistributors: {},
    administrators: {}
};

// REDUCER
export const DistributorReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_DISTRIBUTORS: {
            const incomingDistributors = action.payload;
            const distributors = {};

            incomingDistributors.forEach((distributor) => {
                distributors[distributor.id] = distributor;
            });

            return {
                ...state,
                distributors
            }
        }

        case GET_DISTRIBUTORS_FOR_USER: {
            const incomingDistributors = action.payload;
            const currentUserDistributors = {};

            incomingDistributors.forEach((distributor) => {
                currentUserDistributors[distributor.id] = distributor;
            });

            return {
                ...state,
                currentUserDistributors: currentUserDistributors
            }
        }

        case UPDATE_USER_DISTRIBUTORS: {
            return {
                ...state
            }
        }

        case GET_ADMINISTRATORS: {
            const incomingAdministrators = action.payload;
            const administrators = {};
            
            incomingAdministrators.forEach((administrator) => {
                administrators[administrator] = administrator;
            });

            return {
                ...state,
                administrators
            }
        }

        case UPDATE_ADMINISTRATORS: {
            return {
                ...state
            }
        }

        default:
            return state;
    }
};